// import React, { useState, useEffect } from "react";
// import DashboardLayout from "../../layoutcontainers/DashboardLayout";
// import MaterialTypography from "../../components/MaterialTypography";
// import { Box, Card, CardHeader, Stack, Typography } from "@mui/material";
// import { useNavigate } from "react-router-dom";
// import MaterialButton from "../../components/MaterialButton";
// import AddIcon from "@mui/icons-material/Add";
// import BASEURL from "../Utils/Baseurl";
// import axios from "axios";
// import { useLoading } from "../../context/loading";

// const Payroll = () => {
//   const navigate = useNavigate();
//   const [openUnit, setOpenUnit] = useState(0);
//   const { setCirleLoading } = useLoading();
//   const monthNames = [
//     "January",
//     "February",
//     "March",
//     "April",
//     "May",
//     "June",
//     "July",
//     "August",
//     "September",
//     "October",
//     "November",
//     "December",
//   ];
//   const [pageState, setPageState] = useState({
//     loading: false,
//     error: false,
//     message: "",
//     state: "init",
//   });

//   const [employeeSalaryList, setEmployeeSalaryList] = useState([]);

//   useEffect(() => {
//     onSalaryStructureSubmit();
//   }, []);

//   const handleNewSalaryStructure = () => {
//     navigate("/payroll/add-payroll");
//   };

//   const onSalaryStructureSubmit = async () => {
//     setCirleLoading(true);
//     const query = `
//         query GetAllPayrolls($category: String, $month: Int, $year: Int, $branch: String) {
//   allPayrolls(category: $category, month: $month, year: $year, branch: $branch) {
//     id
//     employee {
//       id
//       firstName
//       lastName
//       empid
//       branch
//       category
//       dateOfJoining
//       employeeType
//       uanNumber
//       esicNumber
//       bankDetails{
//         accountNumber
//         ifscNumber
//         cifNumber
//         branchName
//       	bankName
//       }
//     }
//     month
//     year
//     monthDays
//     salaryDays
//     absentDays
//     mealsDays
//     shiftPaiseDays
//     otHours
//     basicAmount
//     daAmount
//     mealsAmountPerDay
//     otAmountPerHour
//     shiftPaisa
//     attendanceAmount
//     busFare
//     esiAmount
//     pfAmount
//     advanceAmount
//     bonusAmount
//     earnedBasic
//     earnedDa
//     lopAmount
//     otAmount
//     shiftPaiseAmount
//     attendanceAllowance
//     mealsAmount
//     grossPay
//     totalAmount
//     netPay
//   }
// }
//         `;

//     try {
//       setPageState({ ...pageState, loading: true });

//       const response = await axios.post(
//         BASEURL,
//         {
//           query: query,
//         },
//         {
//           headers: {
//             "Content-Type": "application/json",
//           },
//         }
//       );
//       const EmployeeSalaryResponse = response.data.data.allPayrolls;
//       const branchMap = {};

//       EmployeeSalaryResponse.forEach((item) => {
//         const branchName = item.employee.branch;

//         if (!branchMap[branchName]) {
//           branchMap[branchName] = {
//             branch: branchName,
//             payroll: [],
//             uniqueSet: new Set(),
//           };
//         }

//         const key = `${item.year}-${item.month}-${item.employee.category}`;

//         if (!branchMap[branchName].uniqueSet.has(key)) {
//           branchMap[branchName].uniqueSet.add(key);

//           branchMap[branchName].payroll.push({
//             id: item.id,
//             year: item.year,
//             month: item.month,
//             category: item.employee.category,
//           });
//         }
//       });

//       // Convert map to array
//       const formattedData = Object.values(branchMap).map((b) => {
//         delete b.uniqueSet;
//         return b;
//       });

//       console.log(formattedData, "Formatted Branch → Payroll Data");

//       setEmployeeSalaryList(formattedData);
//       setPageState({ ...pageState, loading: false, state: "success" });
//     } catch (error) {
//       console.error("ResponseError:", error);
//       setPageState({
//         ...pageState,
//         loading: false,
//         error: true,
//         message: error.message,
//       });
//     } finally {
//       setCirleLoading(false);
//     }
//   };

//   const toggleUnit = (index) => {
//     setOpenUnit(index); // always opens the one clicked
//   };

//   const handleRowClick = (row) => {
//     navigate(`/payroll/add-payroll`, { state: { data: row } });
//   };
//   return (
//     <DashboardLayout>
//       <Card style={{ minHeight: "400px" }}>
//         <CardHeader
//           title={
//             <Stack
//               direction="row"
//               justifyContent="space-between"
//               alignItems="center"
//               spacing={2}
//             >
//               <Stack direction="column" spacing={0}>
//                 <MaterialTypography variant="h5" fontWeight="medium">
//                   Payroll List
//                 </MaterialTypography>
//               </Stack>

//               <MaterialButton
//                 variant="gradient"
//                 color="dark"
//                 size="small"
//                 startIcon={<AddIcon />}
//                 onClick={() => handleNewSalaryStructure()}
//               >
//                 Run Payroll
//               </MaterialButton>
//             </Stack>
//           }
//         />
//         {employeeSalaryList && employeeSalaryList.length > 0 ? (
//           employeeSalaryList.map((unit, index) => (
//             <Box
//               key={index}
//               onClick={() => toggleUnit(index)}
//               style={{
//                 backgroundColor: "#d9d9f8ff",
//                 color: "#3F51B5d4",
//                 padding: "14px",
//                 borderRadius: "5px",
//                 margin: "8px 20px",
//                 cursor: "pointer",
//                 transition: "0.3s",
//               }}
//             >
//               {/* Unit Name */}
//               <Typography variant="h6" style={{ color: "#3F51B5d4" }}>
//                 {unit.branch}
//               </Typography>

//               {/* Expanded Box */}
//               {openUnit === index && (
//                 <Box
//                   style={{
//                     backgroundColor: "#f0f0ff",
//                     padding: "12px",
//                     marginTop: "12px",
//                     borderRadius: "8px",
//                     color: "#333",
//                   }}
//                   onClick={(e) => e.stopPropagation()} // prevent closing when clicking inside
//                 >
//                   <table style={{ width: "100%", borderCollapse: "collapse" }}>
//                     <thead>
//                       <tr
//                         style={{
//                           color: "#3F51B5d4",
//                           fontSize: "14px",
//                           display: "flex",
//                           justifyContent: "space-between",
//                           alignItems: "center",
//                           padding: "8px",
//                         }}
//                       >
//                         <th style={{ flex: 1, textAlign: "left" }}>Year</th>
//                         <th style={{ flex: 1, textAlign: "left" }}>Month</th>
//                         <th style={{ flex: 1, textAlign: "left" }}>Category</th>
//                       </tr>
//                     </thead>

//                     <tbody>
//                       {unit.payroll.map((row, i) => (
//                         <tr
//                           key={i}
//                           onClick={() => handleRowClick(row)}
//                           style={{
//                             display: "flex",
//                             justifyContent: "space-between",
//                             padding: "10px 12px",
//                             background: i % 2 === 0 ? "#F5F5F5" : "#FFFFFF",
//                             borderBottom: "1px solid #ddd",
//                             cursor: "pointer",
//                             transition: "0.2s",
//                             fontSize: "13px",
//                           }}
//                         >
//                           <td style={{ flex: 1 }}>{row.year}</td>
//                           <td style={{ flex: 1 }}>{row.month}</td>
//                           <td style={{ flex: 1 }}>{row.category}</td>
//                         </tr>
//                       ))}
//                     </tbody>
//                   </table>
//                 </Box>
//               )}
//             </Box>
//           ))
//         ) : (
//           <Box
//             style={{
//               backgroundColor: "#d9d9f8ff",
//               color: "#3F51B5d4",
//               padding: "14px",
//               borderRadius: "5px",
//               margin: "8px 20px",
//               textAlign: "center",
//             }}
//           >
//             <Typography variant="h6">No Data Found</Typography>
//           </Box>
//         )}
//       </Card>
//     </DashboardLayout>
//   );
// };

// export default Payroll;

import React, { useState, useEffect } from "react";
import DashboardLayout from "../../layoutcontainers/DashboardLayout";
import MaterialDataGrid from "../../components/MaterialDataGrid";
import MaterialTypography from "../../components/MaterialTypography";
import { Card, CardHeader, Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";
import MaterialButton from "../../components/MaterialButton";
import AddIcon from "@mui/icons-material/Add";
import BASEURL from "../Utils/Baseurl";
import axios from "axios";

const Payroll = () => {
  const navigate = useNavigate();
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const [pageState, setPageState] = useState({
    loading: false,
    error: false,
    message: "",
    state: "init",
  });

  const [employeeSalaryList, setEmployeeSalaryList] = useState([]);

  useEffect(() => {
    onSalaryStructureSubmit();
  }, []);

  const SalaryStructureListTable = {
    columns: [
      {
        field: "year",
        headerName: "Year",
        flex: 1,

        sortable: true,
      },
      {
        field: "months",
        headerName: "Month",
        flex: 1,

        sortable: true,
      },
      {
        field: "category",
        headerName: "Category",
        width: 300,
        sortable: true,
      },
    ],

    rows: employeeSalaryList.map((manager) => ({
      id: manager.id,
      year: manager.year,
      month: manager.month,
      months: monthNames[manager.month - 1],
      category: manager.category,
    })),
  };

  const handleNewSalaryStructure = () => {
    navigate("/payroll/add-payroll");
  };

  const onEmployeeListClick = (e) => {
    console.log("onEmployeeListClick:", e?.id, e);
    if (e?.id) {
      navigate(`/payroll/add-payroll`, { state: { data: e?.row } });
    }
  };

  const onSalaryStructureSubmit = async () => {
    const query = `
 query GetAllPayrolls($category: String, $month: Int, $year: Int, $branch: String) {
  allPayrolls(category: $category, month: $month, year: $year, branch: $branch) {
    id
    employee {
      id
      firstName
      lastName
      empid
      branch
      category
      dateOfJoining
      employeeType
      uanNumber
      esicNumber
      bankDetails{
        accountNumber
        ifscNumber
        cifNumber
        branchName
      	bankName
      }
    }
    month
    year
    monthDays
    salaryDays
    absentDays
    mealsDays
    shiftPaiseDays
    otHours
    basicAmount
    daAmount
    mealsAmountPerDay
    otAmountPerHour
    shiftPaisa
    attendanceAmount
    busFare
    esiAmount
    pfAmount
    advanceAmount
    bonusAmount
    earnedBasic
    earnedDa
    lopAmount
    otAmount
    shiftPaiseAmount
    attendanceAllowance
    mealsAmount
    grossPay
    totalAmount
    netPay
  }
}
        `;

    try {
      setPageState({ ...pageState, loading: true });

      const response = await axios.post(
        BASEURL,
        {
          query: query,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const EmployeeSalaryResponse = response.data.data.allPayrolls;
      let uniqueSet = new Set();
      let filterdata = [];

      EmployeeSalaryResponse.forEach((val) => {
        const key = `${val.year}-${val.month}-${val.employee.category}`;

        if (!uniqueSet.has(key)) {
          uniqueSet.add(key);
          filterdata.push({
            id: val.id,
            year: val.year,
            month: val.month,
            category: val.employee.category,
          });
        }
      });
      console.log(filterdata, "filterdata");

      setEmployeeSalaryList(filterdata);
      setPageState({ ...pageState, loading: false, state: "success" });
    } catch (error) {
      console.error("ResponseError:", error);
      setPageState({
        ...pageState,
        loading: false,
        error: true,
        message: error.message,
      });
    }
  };

  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  Payroll List
                </MaterialTypography>
              </Stack>

              <MaterialButton
                variant="gradient"
                color="dark"
                size="small"
                startIcon={<AddIcon />}
                onClick={() => handleNewSalaryStructure()}
              >
                Run Payroll
              </MaterialButton>
            </Stack>
          }
        />
        <MaterialDataGrid
          rows={SalaryStructureListTable.rows}
          columns={SalaryStructureListTable.columns}
          checkboxSelection={false}
          isSelectable={false}
          // sortModel={[{ field: 'id', sort: 'desc' }]}
          onRowClick={onEmployeeListClick}
          loading={pageState.loading}
          localeText={{
            noRowsLabel: (
              <Stack
                direction="column"
                alignItems="center"
                justifyContent="center"
                spacing={1}
              >
                <MaterialTypography
                  variant="body2"
                  fontWeight="medium"
                  color="text"
                >
                  No payroll found
                </MaterialTypography>
                <MaterialTypography variant="caption" color="text">
                  You have not yet add any payroll details. Click on the "Run
                  Payroll" button to start adding payroll.
                </MaterialTypography>
              </Stack>
            ),
          }}
        />
      </Card>
    </DashboardLayout>
  );
};

export default Payroll;
